export default __webpack_public_path__ + "static/media/1280.620e0f64.png";